/** Direct Meta Messenger (Graph API Send) operational issues. */
import type { IssueDefinition } from "../issue-definition";
import { ISSUE_CATEGORY, ISSUE_FAULT } from "../issue-enums";

export const MESSENGER_ISSUES = {
  META_MESSENGER_AUTH_FAILED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Meta Page Access Token is invalid or expired",
    severity: "critical",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Messenger connection invalid",
    userGuidance:
      "Your Facebook Page connection is invalid or expired, so the agent can't send or receive Messenger messages. Reconnect the page to restore it."
  },
  META_MESSENGER_PERMISSION_DENIED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Meta denied permission for the Messenger send request",
    severity: "high",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Messenger permission denied",
    userGuidance:
      "Meta refused a Messenger send because the app or page lacks the required permission. Reconnect the page and grant messaging access."
  },
  META_MESSENGER_RATE_LIMIT: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Meta Messenger API rate limit exceeded",
    severity: "medium",
    fault: ISSUE_FAULT.PROVIDER,
    userTitle: "Messenger rate limit reached",
    userGuidance:
      "Meta is rate-limiting Messenger requests. Delivery catches up on its own once the limit clears."
  },
  META_MESSENGER_MESSAGE_SEND_FAILED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Meta Messenger message failed to send",
    severity: "high",
    fault: ISSUE_FAULT.PROVIDER,
    userTitle: "Messenger message not delivered",
    userGuidance:
      "A Messenger message could not be delivered due to a Meta Graph API error. It may succeed on retry; persistent failures usually mean the page connection needs attention."
  }
} as const satisfies Record<string, IssueDefinition>;
